<template>
  <div>
    <MultipleToggle
      :options="toggleOptions"
      :value="viewModel.callRouteDuplicateToggle"
      :disabled="disabled"
      @change="handleToggleChange"
    >
      <div
        v-if="viewModel.callRouteDuplicateToggle === DUPLICATE_CONVERSION_VALUES.TIME_LIMIT"
        class="form-group p-l-0 p-b-0 mt-2"
      >
        <div class="row">
          <div class="col-sm-3 col-md-2 m-0">
            <input
              v-model.number="viewModel.deDupeSetting.days"
              type="number"
              min="0"
              step="1"
              class="form-control"
              :readonly="disabled"
              @change="handleTimeLimitChange"
            >
          </div>
          <label
            class="control-label text-left col-sm-2 col-md-1"
          >
            {{ $t('DAYS') }}
          </label>

          <div class="col-sm-3 col-md-2 m-0">
            <input
              v-model.number="viewModel.deDupeSetting.hours"
              type="number"
              min="0"
              step="1"
              class="form-control"
              :readonly="disabled"
              @change="handleTimeLimitChange"
            >
          </div>
          <label class="control-label text-left col-sm-2 col-md-1 text-left">
            {{ $t('HOURS') }}
          </label>
        </div>
      </div>
    </MultipleToggle>
  </div>
</template>

<script>
import MultipleToggle from '@/core/components/MultipleToggle/MultipleToggle.vue';
import sharedMessages from '@/core/locales';
import messages from '../locales';
import { DUPLICATE_CONVERSION_VALUES } from '../apiConstants';

export default {
  name: 'ConversionDuplicationToggle',
  components: {
    MultipleToggle
  },
  props: {
    viewModel: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      DUPLICATE_CONVERSION_VALUES
    };
  },

  computed: {
    toggleOptions() {
      return [
        {
          name: 'Disable',
          value: DUPLICATE_CONVERSION_VALUES.DISABLE
        },
        {
          name: 'Enable',
          value: DUPLICATE_CONVERSION_VALUES.ENABLE
        },
        {
          name: 'Time Limit',
          value: DUPLICATE_CONVERSION_VALUES.TIME_LIMIT
        }
      ];
    }
  },
  methods: {
    handleToggleChange(option) {
      this.viewModel.toggleValueChanged(option.value);
    },
    handleTimeLimitChange() {
      this.viewModel.inputChange();
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },

};
</script>